import { render, staticRenderFns } from "./HandsRaised.vue?vue&type=template&id=896ce89a&scoped=true&lang=pug"
import script from "./HandsRaised.vue?vue&type=script&lang=ts"
export * from "./HandsRaised.vue?vue&type=script&lang=ts"
import style0 from "./HandsRaised.vue?vue&type=style&index=0&id=896ce89a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896ce89a",
  null
  
)

export default component.exports